module.exports = __webpack_public_path__ + "img/hontai_ItalianRed.d3dce6cb.png";